import { render, staticRenderFns } from "./violationManagement.vue?vue&type=template&id=f9a9053a&scoped=true"
import script from "./violationManagement.vue?vue&type=script&lang=js"
export * from "./violationManagement.vue?vue&type=script&lang=js"
import style0 from "./violationManagement.vue?vue&type=style&index=0&id=f9a9053a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9a9053a",
  null
  
)

export default component.exports